import React from 'react';

import { getVersionInfo } from '../definitions/Config';

const VersionInfo = () => {
  let versionInfo = getVersionInfo();
  let buildNumber = versionInfo.buildNumber;
  buildNumber = buildNumber ? 'v' + buildNumber : buildNumber;

  let gitProperties = versionInfo.gitProperties;
  return (
    <div>
      <span
        className="show-desktop"
        style={{ color: '#808080' }}
        title={gitProperties['git.commit.id.describe']}
      >
        {buildNumber}
      </span>
    </div>
  );
};

export default VersionInfo;
